<app-progress-bar [loading]="loading()" />
<ng-container *transloco="let t">
  <div class="header-row">
    <picture class="logo">
      <source media="(prefers-color-scheme: dark)" srcset="/assets/img/hallohoreca-white.svg" />
      <img alt="HalloHoreca!" height="120" src="/assets/img/hallohoreca-black.svg" width="610" />
    </picture>
    <h1>{{ t('I_WANT_A_CATERING_BUSINESS') }}</h1>
    <div class="main-action-buttons">
      <a mat-flat-button routerLink="/search" class="take-over-button">
        {{ t('TO_TAKE_OVER') }}
        <mat-icon iconPositionEnd svgIcon="arrow_forward"></mat-icon>
      </a>
      <a class="to-leave-button" mat-stroked-button routerLink="/user/advertisements">
        {{ t('TO_LEAVE') }}
        <mat-icon iconPositionEnd svgIcon="arrow_forward"></mat-icon>
      </a>
    </div>
  </div>
  @if (suggestions()?.suggestions?.length) {
    <section class="suggestions">
      <div class="suggestions-header">
        <img alt="" class="mascot-image" height="768" src="/assets/img/mascot-search-2.svg" width="498" />
        <div class="suggestions-text">
          <h2 class="dynamic-header">{{ t('OUR_SUGGESTIONS') }}:</h2>
          <p class="dynamic-paragraph">{{ t('SUGGESTIONS_DESCRIPTION') }}</p>
        </div>
      </div>
      <app-advertisements-carousel [advertisements]="suggestions()?.suggestions ?? []" [categories]="categories()" />
    </section>
  }
  @if (hotspotAdvertisement(); as hotspot) {
    <app-advertisement-hotspot class="homepage-block" [ad]="hotspot" [categories]="categories()" />
  }
  <section class="hotspot-cta homepage-block">
    <h2 class="mat-headline-small">{{ t('HOT_SPOT_CTA') }}</h2>
    <a class="hotspot-cta-button" mat-flat-button routerLink="/user/advertisements/create">{{
      t('DISCOVER_IT_HERE')
    }}</a>
  </section>
  <h2 class="mat-headline-small">{{ t('LATEST_HORECA_NEWS') }}</h2>
  <app-home-news />
  <app-newsletter-block class="homepage-block" />
</ng-container>
